/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect, useMemo } from "react";

import { RiLinkedinBoxFill } from "react-icons/ri";
import {
  HeartIcon,
  MessageCircle,
  Repeat2,
  Heart,
  Cpu,
  Image,
  Users,
  AreaChart,
  Earth,
  Send,
  MessageSquare,
  ThumbsUp,
  ShieldCheck,
  SquareArrowOutUpRight,
  BadgeCheck,
  SquareUserRound,
  Briefcase,
  MapPin,
} from "lucide-react";
import { BiRepost } from "react-icons/bi";
import { IoPeopleOutline } from "react-icons/io5";
import { MdAutoGraph } from "react-icons/md";
import { CartesianGrid, Bar, Pie, BarChart, PieChart } from "recharts";

import { useBrand } from "@/Providers/Brand";
import { useStaticData } from "@/Providers/Data";

import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  ChartLegend,
  ChartLegendContent,
} from "@/shadcnComponents/ui/chart";
import { Separator } from "@/shadcnComponents/ui/separator";

import {
  CollaborationPortfolioCard,
  MonetizationAvenueCard,
  SectionCard,
  TagChip,
} from "../../../LockedCreatorDetails/LockedCreatorDetails";
import {
  HighlightMetricsCard,
  InfluPostCard,
  NoActivePlanAlertButton,
  SampleCampaignAlertButton,
  SelectInfluButton,
} from "../Components";

import {
  convertToYearsMonthsBracket,
  formatFollowersCount,
  formatNumberWithCommas,
} from "@/Helpers/format-helper";
import { getRandomProfileEmoji, OpenInNewWindow } from "@/Helpers/helper";
import { Tooltip as RechartsTooltip } from "recharts";
import {
  convertToUrl,
  CustomTooltip,
} from "@/Pages/Influencer/PublicProfile/Component";
import { FaLinkedinIn } from "react-icons/fa";
import { cn } from "../../../../../../lib/utils";
import { format } from "date-fns";
import mixpanel from "mixpanel-browser";
import {
  NewCampaignInfluencerProfile,
  NewCampaignMasterData,
} from "../../CampaignInterface/NewCampaignInterface";
import { CreatorSizeTag } from "../../Helpers/Helper";
import InfluencerFrequencyChart from "./NewCampaignPostFrequency";

export const DetailsPopupV1 = ({
  influencer,
  masterData,
  isSelected,
  onClick,
  index,
}: {
  influencer: any;
  masterData: any;
  isSelected?: boolean;
  onClick?: () => void;
  index?: number;
}) => {
  const brandState = useBrand();
  const [influDataBySlug, setInfluDataBySlug] = useState<any>({});

  useEffect(() => {
    async function getInfluDataBySlug() {
      const result = await brandState?.getInfluencerPersonalDataForCollabBySlug(
        influencer?.slug || ""
      );
      if (result) {
        setInfluDataBySlug(result?.resolvedInfluencers);
      }
    }
    getInfluDataBySlug();
  }, []);
  return (
    <>
      <div
        style={{ scrollbarWidth: "none" }}
        className="w-full max-h-[90vh] overflow-auto flex flex-col gap-6 "
      >
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-5">
            <img
              className="w-[70px] h-[70px] rounded-[8px] "
              src={influencer?.profile}
              alt=""
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              onError={(e: any) => {
                const randomProfileEmoji = getRandomProfileEmoji();
                e.target.onerror = null;
                e.target.src = randomProfileEmoji;
              }}
            />
            <div className="flex flex-col gap-1 justify-between">
              <p className="font-bold text-start  text-lg text-[#212121]">
                {influencer?.name}
              </p>

              {influencer?.badge && (
                <div className="flex py-2 px-4 items-center gap-2 bg-[#2EAFF133] rounded-full">
                  <RiLinkedinBoxFill size={20} color="#0076B2" fill="#0076B2" />
                  <span className="text-[#6767B8] text-center font-[Inter] text-sm not-italic font-normal leading-[normal]">
                    {influencer?.badge}
                  </span>
                </div>
              )}
            </div>
          </div>
          <SelectInfluButton
            isSelected={isSelected}
            onClick={onClick}
            index={index}
          />
        </div>
        <div className="flex gap-[90px]">
          {[
            // {
            //   title: "Current Profession",
            //   value: influencer?.currentPosition?.position || "NA",
            // },
            {
              title: "Total Experience",
              value:
                convertToYearsMonthsBracket(influencer?.totalExperienceYears) ||
                "NA",
            },
          ]?.map((item, i) => (
            <div key={i} className="flex flex-col gap-1">
              <span className="text-[#121212] font-[Inter] text-sm not-italic font-normal leading-[20px]">
                {item?.value}
              </span>
              <span className="text-[#9E9E9E] font-[Inter] text-sm not-italic font-semibold leading-[20px]">
                {item?.title}
              </span>
            </div>
          ))}
        </div>

        <div className="w-full flex flex-col gap-3">
          {[
            <DetailsPopupOverview influencer={influencer} />,

            <div className="flex flex-col gap-3 md:grid grid-cols-2">
              {influencer?.LinkedinAnalysis && (
                <DetailsPopupChart
                  firstThirtyComments={
                    influencer?.LinkedinAnalysis?.latestComments
                  }
                  firstThirtyLikes={influencer?.LinkedinAnalysis?.latestLikes}
                />
              )}

              {(influencer?.CreateCount ||
                influencer?.TotalPostCount - influencer?.CreateCount) && (
                <DetailsPopupPieChartCreateCuratePosts
                  createPostCount={influencer?.CreateCount}
                  curatePostCount={
                    influencer?.TotalPostCount - influencer?.CreateCount
                  }
                />
              )}
            </div>,
            <>
              {influencer?.LinkedinAnalysis?.topEngagedPosts &&
                influencer?.LinkedinAnalysis?.topEngagedPosts?.length > 0 && (
                  <>
                    <DetailsPopupTopPosts
                      TopPosts={influencer?.LinkedinAnalysis?.topEngagedPosts?.slice(
                        0,
                        3
                      )}
                      influencer={influencer}
                    />
                    <VerticalDivider />
                  </>
                )}
            </>,
            <>
              {influDataBySlug?.collabData &&
                influDataBySlug?.collabData?.length > 0 && (
                  <>
                    <DetailsPopupCollab
                      AllCollabs={influDataBySlug?.collabData}
                    />
                    <VerticalDivider />
                  </>
                )}
            </>,
            <>
              {influDataBySlug?.MonetizedData?.data &&
                influDataBySlug?.MonetizedData?.data?.length > 0 && (
                  <>
                    <DetailsPopupMonetization
                      AllMonetization={influDataBySlug?.MonetizedData?.data}
                    />
                    <VerticalDivider />
                  </>
                )}
            </>,
            <div className="flex flex-col gap-3 md:flex-row items-stretch">
              {influencer?.ScrapedCategory &&
                influencer?.ScrapedCategory?.length > 0 && (
                  <div className="flex-1 min-w-1/2 grid">
                    <DetailsPopupContentCategory
                      contentCategory={influencer?.ScrapedCategory}
                      masterData={masterData}
                    />
                  </div>
                )}

              {influDataBySlug?.AudienceCategory &&
                influDataBySlug?.AudienceCategory?.length > 0 && (
                  <div className="flex-1 min-w-1/2 grid">
                    <DetailsPopupAudienceCategory
                      AudienceCategory={influDataBySlug?.AudienceCategory}
                    />
                  </div>
                )}
            </div>,
          ]?.map((item, index) => {
            if (!item) return null;
            return (
              <React.Fragment key={index}>
                {item}
                {/* {index !== array.length - 1 && <VerticalDivider />} */}
              </React.Fragment>
            );
          })}

          <div className="w-full flex justify-center py-10">
            <SelectInfluButton
              isSelected={isSelected}
              onClick={onClick}
              index={index}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export const DetailsPopupOverview = ({ influencer }) => {
  return (
    <>
      <div className="w-full">
        <SectionCard
          icon={"🫱🏼‍🫲🏽"}
          title="Profile Highlights"
          subtitle="Quick glimpse of the stats"
          children={
            <div
              className="grid grid-cols-2 md:flex flex-row gap-[15px] w-full overflow-x-auto py-2 px-1"
              style={{ scrollbarWidth: "none" }}
            >
              {[
                {
                  icon: <IoPeopleOutline color="#568CDD" size={25} />,
                  key: "Total Followers",
                  value:
                    influencer?.cleanedFollowers &&
                    influencer?.cleanedFollowers > 0
                      ? influencer?.cleanedFollowers.toString()?.length > 7
                        ? formatFollowersCount(influencer?.cleanedFollowers)
                        : formatNumberWithCommas({
                            num: influencer?.cleanedFollowers,
                          })
                      : "NA",
                  bgColor: "bg-[#D5E5FF]",
                },
                {
                  icon: <MdAutoGraph color="#F59E00" size={25} />,
                  bgColor: "bg-[#FFF1DD]",
                  key: "Avg Eng.",
                  value: influencer?.LinkedinAnalysis?.avgEngagementPercentage
                    ? `${
                        Math.ceil(
                          influencer?.LinkedinAnalysis
                            ?.avgEngagementPercentage * 10
                        ) / 10
                      }%`
                    : 0,
                },
                {
                  icon: <HeartIcon color="#DC2627" size={25} />,
                  bgColor: "bg-[#FFE8E8]",
                  key: "Avg Likes",
                  value: influencer?.LinkedinAnalysis?.avgLikes
                    ? formatFollowersCount(
                        Math.ceil(influencer?.LinkedinAnalysis?.avgLikes)
                      )
                    : 0,
                },
                {
                  icon: <MessageCircle color="#1070E0" size={25} />,
                  bgColor: "bg-[#CEEBFF]",
                  key: "Avg Comments",
                  value: influencer?.LinkedinAnalysis?.avgComments
                    ? formatFollowersCount(
                        Math.ceil(influencer?.LinkedinAnalysis?.avgComments)
                      )
                    : 0,
                },
                {
                  icon: <Repeat2 color="#13931D" size={25} />,
                  bgColor: "bg-[#D5FFED]",
                  key: "Avg. Reposts",
                  value: influencer?.LinkedinAnalysis?.avgReposts
                    ? formatFollowersCount(
                        Math.ceil(influencer?.LinkedinAnalysis?.avgReposts)
                      )
                    : 0,
                },
              ]?.map((item) => {
                if (item.value === 0) return null;
                return (
                  <>
                    <HighlightMetricsCard
                      title={item?.key}
                      value={item?.value}
                      icon={item?.icon}
                      bgColor={item?.bgColor}
                    />
                  </>
                );
              })}
            </div>
          }
        />
      </div>
    </>
  );
};

export const DetailsPopupChart = ({
  firstThirtyLikes,
  firstThirtyComments,
}) => {
  const chartData = firstThirtyLikes?.map((item, index) => {
    const originalLikes = parseInt(item);
    const originalComments = parseInt(firstThirtyComments?.[index] || 0);
    const likesLog = Math.log10(originalLikes + 1);
    const commentsLog = Math.log10(originalComments + 1);

    return {
      month: `post ${index + 1}`,
      likes: likesLog,
      comments: commentsLog,
      originalLikes,
      originalComments,
    };
  });
  const chartConfig = {
    comments: {
      label: "Comments",
      color: "hsl(347 77% 50%)",
    },
    likes: {
      label: "Likes",
      color: "hsl(352 83% 91%)",
    },
  } satisfies ChartConfig;
  return (
    <>
      <div className="w-full">
        <SectionCard
          icon={"💭"}
          title="Post-wise Engagement"
          subtitle="A trend of their engagement, post-wise"
          children={
            <div className="w-full items-center justify-center flex flex-col gap-2">
              <ChartContainer
                className="my-auto h-[250px] px-4"
                config={chartConfig}
              >
                <BarChart accessibilityLayer data={chartData?.reverse()}>
                  <CartesianGrid vertical={false} />
                  <RechartsTooltip content={<CustomTooltip />} cursor={false} />

                  <ChartLegend content={<ChartLegendContent />} />
                  <Bar
                    width={60}
                    dataKey="likes"
                    stackId="a"
                    fill="var(--color-likes)"
                    radius={[0, 0, 4, 4]}
                  />
                  <Bar
                    width={60}
                    dataKey="comments"
                    stackId="a"
                    fill="var(--color-comments)"
                    radius={[4, 4, 0, 0]}
                  />
                </BarChart>
              </ChartContainer>
              <Separator className="w-1/2" />
              <div className="w-1/2 flex items-center justify-between">
                <span className=" text-xs font-medium leading-[14.52px] text-center text-[#424242]">
                  Oldest
                </span>
                <span className=" text-xs font-medium leading-[14.52px] text-center text-[#424242]">
                  Latest
                </span>
              </div>
            </div>
          }
        />
      </div>
    </>
  );
};

export const DetailsPopupPieChartCreateCuratePosts = ({
  createPostCount,
  curatePostCount,
}: {
  createPostCount: number;
  curatePostCount: number;
}) => {
  const chartData = [
    { name: "create", value: createPostCount, fill: "hsl(347 77% 50%)" },
    { name: "curate", value: curatePostCount, fill: "hsl(352 83% 91%)" },
  ];

  const chartConfig = {
    create: {
      label: "Created Content",
      color: "hsl(347 77% 50%)",
    },
    curate: {
      label: "Curated Content",
      color: "hsl(352 83% 91%)",
    },
  } satisfies ChartConfig;

  return (
    <div className="w-full">
      <SectionCard
        icon={"💭"}
        title="Content Creation Style"
        subtitle="2 major styles of content exist - Original thoughts on a topic & lists put together using multiple sources"
        sectionClass="h-full"
        children={
          <div className="w-full">
            <ChartContainer
              config={chartConfig}
              className="mx-auto aspect-square h-[250px]"
              // className="m-auto w-1/2"
            >
              <PieChart>
                <ChartTooltip
                  cursor={false}
                  content={<ChartTooltipContent hideLabel />}
                />
                <Pie data={chartData} dataKey="value" nameKey="name" />
                <ChartLegend content={<ChartLegendContent />} />
              </PieChart>
            </ChartContainer>
          </div>
        }
      />
    </div>
  );
};

export const DetailsPopupCollab = ({ AllCollabs }) => {
  const staticDataState = useStaticData();
  const [masterCollabGoals, setMasterCollabGoals] = useState([]);

  useEffect(() => {
    staticDataState?.getNewDataFromType("Goal / KPI").then((e) => {
      setMasterCollabGoals(e);
    });
  }, []);

  return (
    <>
      <SectionCard
        title="Past Collaborations"
        subtitle="The creator has collaborated with these companies & helped them to grow"
        icon={"🫱🏼‍🫲🏽"}
      >
        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {AllCollabs?.map((collab, index) => {
            return (
              <CollaborationPortfolioCard
                key={index}
                companyName={collab?.companyName}
                companyUrl={collab?.companyUrl}
                goals={collab?.goals}
                postLink={collab?.postLink}
                isVerified={collab?.isVerified}
                masterData={masterCollabGoals}
                postContent={collab?.scrapedData?.postContent}
              />
            );
          })}
        </div>
      </SectionCard>
    </>
  );
};

export const DetailsPopupMonetization = ({ AllMonetization }) => {
  const staticDataState = useStaticData();
  const [masterMonetizationPlatform, setMasterMonetizationPlatform] = useState(
    []
  );
  const [masterMonetizationServices, setMasterMonetizationServices] = useState(
    []
  );

  useEffect(() => {
    staticDataState?.getNewDataFromType("Platform Name").then((e) => {
      setMasterMonetizationPlatform(e);
    });
    staticDataState?.getNewDataFromType("Services list").then((e) => {
      setMasterMonetizationServices(e);
    });
  }, []);
  return (
    <>
      <SectionCard
        title="Monetization Channels"
        subtitle="I am monetizing from following platform"
        icon={"🫱🏼‍🫲🏽"}
      >
        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {AllMonetization?.map((data, index) => {
            return (
              <MonetizationAvenueCard
                key={index}
                platformname={
                  masterMonetizationPlatform?.find(
                    (platform) => platform?._id === data?.platformName
                  )?.monetizationPlatformName
                }
                profileLink={data?.profileLink}
                paidAudience={data?.paidAudience}
                methods={data?.methods?.map((method) => {
                  const methodName = masterMonetizationServices?.find(
                    (mastermethod) => mastermethod?._id === method
                  );
                  return methodName?.monetizationServiceName;
                })}
                plateformLogo={
                  masterMonetizationPlatform?.find(
                    (platform) => platform?._id === data?.platformName
                  )?.monetizationPlatformIcon
                }
              />
            );
          })}
        </div>
      </SectionCard>
    </>
  );
};

export const DetailsPopupContentCategory = ({
  contentCategory,
  masterData,
}) => {
  return (
    <SectionCard
      title="Content Category"
      subtitle="The influencer majorly talks on these topics and categories"
      icon={"💭"}
    >
      <div className="flex items-start gap-[8px] flex-wrap">
        {contentCategory?.map((category, index) => (
          <TagChip
            key={index}
            text={`${
              masterData?.ContentCategory?.find((Cc) => Cc?._id == category)
                ?.categoryName || category
            }`}
            variant={"colored"}
          />
        ))}
      </div>
    </SectionCard>
  );
};

export const DetailsPopupAudienceCategory = ({ AudienceCategory }) => {
  const staticDataState = useStaticData();
  const [masterAudienceTypes, setMasterAudienceTypes] = useState([]);

  useEffect(() => {
    staticDataState
      ?.getNewDataFromType("lkd_super_master_audienceType")
      .then((e) => {
        setMasterAudienceTypes(e);
      });
  }, []);
  return (
    <SectionCard
      title="Audience Category"
      subtitle="The influencer has these people in their audience"
      icon={"💭"}
    >
      <div className="flex items-start gap-[8px] flex-wrap">
        {AudienceCategory?.slice(0, 6)?.map((audiencePlatformIcon, index) => (
          <TagChip
            key={index}
            text={`${
              audiencePlatformIcon?.value ||
              masterAudienceTypes?.find((Cc) => Cc?._id == audiencePlatformIcon)
                ?.LkdAudienceTypeName
            }`}
            variant={"colored"}
          />
        ))}
        {AudienceCategory?.length > 6 && (
          <TagChip
            text={`${
              AudienceCategory?.length > 6
                ? `+${AudienceCategory?.length - 6} more`
                : ""
            }`}
            variant={"colored"}
          />
        )}
      </div>
    </SectionCard>
  );
};

export const TopPostCard = ({
  profile,
  name,
  postDescription,
  likes,
  comments,
  reposts,
  postLink,
}) => {
  return (
    <>
      <div className="w-1/2 p-4 flex flex-col  gap-[20px]  border border-solid border-[#DBDBDB] rounded-[6px]">
        <div className="w-full items-center justify-start flex gap-2 ">
          <div className="overflow-hidden w-[40px] h-[40px]  rounded-full  ">
            <img
              className="w-[40px] h-[40px] cover"
              src={profile}
              alt=""
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              onError={(e: any) => {
                const randomProfileEmoji = getRandomProfileEmoji();
                e.target.onerror = null;
                e.target.src = randomProfileEmoji;
              }}
            />
          </div>
          <div className=" flex flex-col gap-1">
            <span className=" text-xs font-semibold leading-[14.52px] text-left text-[#121212] ">
              {name}
            </span>
          </div>
        </div>
        <div className="flex flex-wrap flex-col gap-1 ">
          <div className="break-all text-xs font-normal leading-[14.52px] text-left text-[#666666] line-clamp-4">
            {postDescription}
          </div>
          <span
            onClick={() => OpenInNewWindow({ link: postLink })}
            className=" cursor-pointer text-xs font-bold leading-[14.52px] text-left text-[#666666] line-clamp-4"
          >
            view more
          </span>
        </div>

        <div className=" flex gap-[20px] ">
          {[
            {
              icon: <Heart size={24} color="#FF8A8A" />,
              key: "Avg. Engagement",
              value: `${likes ?? "NA"}`,
            },
            {
              icon: <MessageCircle size={20} color="#FF8A8A" />,
              key: "Avg. Likes",
              value: `${comments ?? "NA"}`,
            },
            {
              icon: <BiRepost size={20} color="#FF8A8A" />,
              key: "Avg. Comments",
              value: `${reposts ?? "NA"}`,
            },
          ]?.map((item) => (
            <div className="flex gap-1 items-center  @apply text-xs font-normal leading-[14.52px] text-left text-[#666666]">
              {item.icon}
              {item.value}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export const DetailsPopupTopPosts = ({ TopPosts, influencer }) => {
  return (
    <SectionCard
      title="Most Engaged Posts"
      subtitle="Top 3 posts with the highest engagement"
      icon={"🫱🏼‍🫲🏽"}
    >
      <div
        className="w-full flex gap-4 overflow-x-auto py-2 px-1"
        style={{ scrollbarWidth: "none" }}
      >
        {TopPosts?.map((post, index) => (
          <InfluPostCard
            key={index}
            profile={influencer?.profile}
            name={influencer?.name}
            postDescription={post?.postDescription}
            likes={post?.likes}
            comments={post?.comments}
            reposts={post?.reposts}
            postLink={post?.postFeedUrl}
            tagline={influencer?.tagline}
          />
        ))}
      </div>
    </SectionCard>
  );
};

const VerticalDivider = () => {
  return (
    <div className="flex items-center justify-center">
      <div className="h-[40px] min-h-[1em] w-px self-stretch bg-gradient-to-tr from-transparent via-neutral-500 to-transparent opacity-25 dark:via-neutral-400"></div>
    </div>
  );
};

// ------ Detailed Popup V2 ------

enum SectionView {
  ALL = "all",
  PROFILE_HIGHLIGHT = "profileHighlight",
  PAST_COLLAB = "pastCollab",
  MOST_ENGAGED_POSTS = "mostEngagedPosts",
  ENGAGEMENT_DETAILS = "engagementDetails",
  CONTENT_DETAILS = "contentDetails",
  AUDIENCE_DETAILS = "audienceDetails",
}

enum SectionViewFilterKey {
  OVERALL = "overall",
  NICHE_CONTENT = "nicheContent",
  AUDIENCE = "audience",
  PAST_COLLAB = "pastCollab",
}

type FilterOption = {
  title: string;
  key: SectionViewFilterKey;
};

const FilterOptions: FilterOption[] = [
  {
    title: "Overall",
    key: SectionViewFilterKey.OVERALL,
  },
  {
    title: "Content Niche",
    key: SectionViewFilterKey.NICHE_CONTENT,
  },
  {
    title: "Audience",
    key: SectionViewFilterKey.AUDIENCE,
  },
  {
    title: "Past Collabs",
    key: SectionViewFilterKey.PAST_COLLAB,
  },
];

type ProfileMetricType = {
  icon: React.ReactNode;
  key: string;
  value: string;
  bgColor: string;
};

interface DetailedPopupProps {
  influencer: NewCampaignInfluencerProfile;
  masterData: NewCampaignMasterData;
  isSelected?: boolean;
  onClick?: () => void;
  index?: number;
}

export const DetailsPopup: React.FC<DetailedPopupProps> = ({
  influencer,
  masterData,
  isSelected,
  onClick,
  index,
}) => {
  const brandState = useBrand();
  const [influDataBySlug, setInfluDataBySlug] = useState<any>({});

  useEffect(() => {
    mixpanel.track("Influencer Details Sheet Viewed", {
      influencerSlug: influencer?.slug,
    });

    async function getInfluDataBySlug() {
      const result = await brandState?.getInfluencerPersonalDataForCollabBySlug(
        influencer?.slug || ""
      );
      if (result) {
        setInfluDataBySlug(result?.resolvedInfluencers);
      }
    }
    getInfluDataBySlug();
  }, []);

  const profileMetrics = useMemo(() => {
    const Metrics: ProfileMetricType[] = [
      {
        icon: <IoPeopleOutline color="#568CDD" size={25} />,
        key: "Total Followers",
        value:
          influencer?.cleanedFollowers && influencer?.cleanedFollowers > 0
            ? influencer?.cleanedFollowers.toString()?.length > 7
              ? formatFollowersCount(influencer?.cleanedFollowers)
              : formatNumberWithCommas({
                  num: influencer?.cleanedFollowers,
                })
            : "NA",
        bgColor: "bg-[#D5E5FF]",
      },
      {
        icon: <HeartIcon color="#DC2627" size={25} />,
        bgColor: "bg-[#FFE8E8]",
        key: "Avg. Likes",
        value: influencer?.LinkedinAnalysis?.avgLikes
          ? formatFollowersCount(
              Math.ceil(influencer?.LinkedinAnalysis?.avgLikes)
            )
          : 0,
      },
      {
        icon: <MessageCircle color="#1070E0" size={25} />,
        bgColor: "bg-[#CEEBFF]",
        key: "Avg. Comments",
        value: influencer?.LinkedinAnalysis?.avgComments
          ? formatFollowersCount(
              Math.ceil(influencer?.LinkedinAnalysis?.avgComments)
            )
          : 0,
      },

      {
        icon: <Repeat2 color="#13931D" size={25} />,
        bgColor: "bg-[#D5FFED]",
        key: "Avg. Reposts",
        value: influencer?.LinkedinAnalysis?.avgReposts
          ? formatFollowersCount(
              Math.ceil(influencer?.LinkedinAnalysis?.avgReposts)
            )
          : 0,
      },
      {
        icon: <MdAutoGraph color="#F59E00" size={25} />,
        bgColor: "bg-[#FFF1DD]",
        key: "Avg. ER",
        value: influencer?.LinkedinAnalysis?.avgEngagementPercentage
          ? `${
              Math.ceil(
                influencer?.LinkedinAnalysis?.avgEngagementPercentage * 10
              ) / 10
            }%`
          : 0,
      },
    ];
    return Metrics;
  }, [influencer]);

  // filter view logic

  const [sectionVisibility, setSectionVisibility] = useState({});
  const [selectedFilter, setSelectedFilter] = useState({
    sectionView: [SectionViewFilterKey.OVERALL],
  });

  // Centralized conditions for section visibility
  const sectionConditions = useMemo(() => {
    return {
      [SectionView.PROFILE_HIGHLIGHT]: () => true,
      [SectionView.PAST_COLLAB]: () => influDataBySlug?.collabData?.length > 0,
      [SectionView.MOST_ENGAGED_POSTS]: () =>
        influencer?.LinkedinAnalysis?.topEngagedPosts?.length > 0,
      [SectionView.ENGAGEMENT_DETAILS]: () => !!influencer?.LinkedinAnalysis,
      [SectionView.CONTENT_DETAILS]: () =>
        influencer?.CreateCount > 0 ||
        influencer?.TotalPostCount - influencer?.CreateCount > 0 ||
        (influencer?.categoryWithScore &&
          influencer?.categoryWithScore?.length > 0),
      [SectionView.AUDIENCE_DETAILS]: () =>
        !!influencer?.demographicsWithPercentage &&
        (influencer?.demographicsWithPercentage?.jobTitles?.length > 0 ||
          influencer?.demographicsWithPercentage?.locations?.length > 0 ||
          influencer?.demographicsWithPercentage?.seniority?.length > 0),
    };
  }, [influencer, influDataBySlug]);

  // Update section visibility based on selected filter
  const updateSectionVisibility = (filterKey) => {
    if (filterKey === SectionViewFilterKey.OVERALL) {
      setSectionVisibility(
        Object.fromEntries(
          Object.keys(sectionConditions).map((key) => [
            key,
            sectionConditions[key](),
          ])
        )
      );
    } else if (filterKey === SectionViewFilterKey.PAST_COLLAB) {
      setSectionVisibility({
        [SectionView.PAST_COLLAB]: sectionConditions[SectionView.PAST_COLLAB](),
      });
    } else if (filterKey === SectionViewFilterKey.NICHE_CONTENT) {
      setSectionVisibility({
        [SectionView.CONTENT_DETAILS]:
          sectionConditions[SectionView.CONTENT_DETAILS](),
        [SectionView.ENGAGEMENT_DETAILS]:
          sectionConditions[SectionView.ENGAGEMENT_DETAILS](),
        [SectionView.MOST_ENGAGED_POSTS]:
          sectionConditions[SectionView.MOST_ENGAGED_POSTS](),
      });
    } else if (filterKey === SectionViewFilterKey.AUDIENCE) {
      setSectionVisibility({
        [SectionView.AUDIENCE_DETAILS]:
          sectionConditions[SectionView.AUDIENCE_DETAILS](),
      });
    }
  };

  // Handle filter change
  const handleFilterChange = (key) => {
    mixpanel.track("Influencer Details Sheet View Filter Change", {
      filterKey: key,
    });

    setSelectedFilter({ sectionView: [key] });
    updateSectionVisibility(key);
  };

  const [filterOptions, setFilterOptions] =
    useState<FilterOption[]>(FilterOptions);

  // Remove options for audience and past collab if they do not match the section conditions
  useEffect(() => {
    const updatedFilterOptions = FilterOptions.filter((option) => {
      if (
        option?.key === SectionViewFilterKey.AUDIENCE &&
        !sectionConditions[SectionView.AUDIENCE_DETAILS]()
      ) {
        return false;
      }
      if (
        option?.key === SectionViewFilterKey.PAST_COLLAB &&
        !sectionConditions[SectionView.PAST_COLLAB]()
      ) {
        return false;
      }
      return true;
    });

    setFilterOptions(updatedFilterOptions);
    updateSectionVisibility(SectionViewFilterKey.OVERALL);
  }, [influencer, influDataBySlug]);

  return (
    <>
      <div
        style={{ scrollbarWidth: "none" }}
        className="relative w-full h-screen overflow-y-auto flex flex-col gap-6 text-black p-8 overflow-x-hidden font-inter"
      >
        {/* Top Gradient */}
        <div className="absolute top-0 w-full bg-gradient-to-r from-[#F7FAFEB2] via-[#E7EFFFB2] to-[#8FC1FFB2] h-[100px]" />

        {/* Profile */}
        <div className="relative h-fit my-3">
          <IProfileV2
            profileImage={influencer?.profile}
            name={influencer?.name}
            topVoiceBadge={influencer?.badge}
            creatorSize={CreatorSizeTag(masterData, influencer)}
          />
        </div>

        {/* Filter view */}
        <div className="sticky -top-8 z-10 bg-[#FBFBFB] pb-2.5">
          <FilterView
            options={filterOptions}
            selectedOptions={selectedFilter?.sectionView}
            onChange={(option) => handleFilterChange(option?.key)}
          />
        </div>

        {/* Profile Highlights */}
        {sectionVisibility[SectionView.PROFILE_HIGHLIGHT] && (
          <ProfileHighlightsV2 profileMetrics={profileMetrics} />
        )}

        {/* Content Details */}
        {sectionVisibility[SectionView.CONTENT_DETAILS] && (
          <ContentDetailsV2
            createPostCount={influencer?.CreateCount}
            curatePostCount={
              influencer?.TotalPostCount - influencer?.CreateCount
            }
            categoryWithScore={influencer?.categoryWithScore}
            masterData={masterData}
          />
        )}

        {/* Engagement Details */}
        {sectionVisibility[SectionView.ENGAGEMENT_DETAILS] && (
          <EngagementDetailsV2
            firstThirtyComments={influencer?.LinkedinAnalysis?.latestComments}
            firstThirtyLikes={influencer?.LinkedinAnalysis?.latestLikes}
          />
        )}

        {/* frequency Chart */}
        <InfluencerFrequencyChart data={influDataBySlug?.postFrequency} />

        {/* Most Engaged Posts */}
        {sectionVisibility[SectionView.MOST_ENGAGED_POSTS] && (
          <MostEngagedPostsV2
            topPosts={influencer?.LinkedinAnalysis?.topEngagedPosts?.slice(
              0,
              3
            )}
            name={influencer?.name}
            tagline={influencer?.tagline}
            profileImage={influencer?.profile}
          />
        )}

        {/* Audience Details */}
        {sectionVisibility[SectionView?.AUDIENCE_DETAILS] && (
          <AudienceDetailsV2
            jobTitles={influencer?.demographicsWithPercentage?.jobTitles}
            locations={influencer?.demographicsWithPercentage?.locations}
            seniority={influencer?.demographicsWithPercentage?.seniority}
          />
        )}

        {/* Past Collaborations */}
        {sectionVisibility[SectionView.PAST_COLLAB] && (
          <PastCollaborationsV2 AllCollabs={influDataBySlug?.collabData} />
        )}

        {/* Footer */}
        <div className="w-full flex justify-center">
          <SampleCampaignAlertButton
            Button={
              <NoActivePlanAlertButton
                Button={
                  <SelectInfluButton
                    isSelected={isSelected}
                    onClick={onClick}
                    index={index}
                  />
                }
                onClick={onClick}
              />
            }
            isSampleInfluencer={influencer?.isSampleInfluencer}
          />
        </div>
      </div>
    </>
  );
};

interface IProfileV2Props {
  profileImage: string;
  name: string;
  topVoiceBadge: string;
  totalExperienceYears?: number;
  creatorSize?: string;
}

function IProfileV2({
  profileImage,
  name,
  topVoiceBadge,
  creatorSize,
}: IProfileV2Props) {
  return (
    <div className="flex gap-5 w-full">
      <div className="relative shrink-0 bg-white p-1.5 w-[150px] h-[150px] rounded-[8px] flex items-center justify-center">
        <img
          className="rounded-[8px] object-cover w-full h-full"
          src={profileImage}
          alt=""
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onError={(e: any) => {
            const randomProfileEmoji = getRandomProfileEmoji();
            e.target.onerror = null;
            e.target.src = randomProfileEmoji;
          }}
        />
        {/* hide badge under profile image */}
        {false && topVoiceBadge && (
          <div className="absolute -bottom-3 w-full flex items-center justify-center px-4">
            <div className="max-w-[118px] flex py-1.5 px-4 items-center gap-2 bg-[#0076B2] text-white rounded-full">
              <FaLinkedinIn
                size={14}
                color="#0076B2"
                fill="#ffff"
                className="shrink-0"
              />
              <span className="text-white text-center font-[Inter] text-xs not-italic font-normal leading-[normal] overflow-hidden text-ellipsis whitespace-nowrap">
                {topVoiceBadge}
              </span>
            </div>
          </div>
        )}
      </div>
      <div className="flex flex-col gap-5 justify-between w-full mt-4 h-full">
        <div className="flex justify-end gap-2">
          <TagChipV2
            text="ACTUAL, SYNCED DATA"
            icon={<BadgeCheck size={14} />}
            bgColor="bg-[#4DB96E]"
            textColor="text-white"
          />
        </div>
        <div className="h-full">
          <div className="flex items-center gap-3">
            <h1 className="font-bold text-start  text-[28px] text-[#212121]">
              {name}
            </h1>
          </div>
          <div className="flex gap-3">
            {creatorSize && (
              <TagChipV2
                text={creatorSize}
                icon={<SquareUserRound size={14} />}
                index={1}
                bgColor="bg-[#FF8A8A1F]"
                textColor="text-[#FF8A8A]"
              />
            )}
            {topVoiceBadge && (
              <TagChipV2
                text={topVoiceBadge}
                icon={<FaLinkedinIn size={14} />}
                index={1}
                bgColor="bg-[#e2eff6]"
                textColor="text-[#117EB8]"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

interface SectionCardV2Props {
  title: string;
  description?: string;
  children: React.ReactNode;
}

function SectionCardV2({ title, description, children }: SectionCardV2Props) {
  return (
    <div className="w-full flex flex-col gap-2.5 font-inter">
      {/* Header */}
      <div className="flex flex-col gap-1">
        <h2 className="text-[#4E73E2] font-[Inter] text-[14px] not-italic font-semibold leading-[20px]">
          {title}
        </h2>
        <p className="text-[#9C9C9C] font-[Inter] text-[12px] not-italic font-medium leading-[normal]">
          {description}
        </p>
      </div>

      {/* Body */}
      {children}
    </div>
  );
}

//  -------------- Filter View V2 --------------

interface FilterViewProps {
  options: FilterOption[];
  onChange: (option: FilterOption) => void;
  selectedOptions: string[];
}
function FilterView({ options, onChange, selectedOptions }: FilterViewProps) {
  return (
    <SectionCardV2 title="Filter View">
      {/* Filter view content */}
      <div className="w-full flex gap-2.5 text-black">
        {options.map((option, index) => (
          <FilterChip
            key={index}
            title={option?.title}
            selected={selectedOptions?.includes(option?.key)}
            onClick={() => onChange(option)}
          />
        ))}
      </div>
    </SectionCardV2>
  );
}

function FilterChip({
  title,
  selected,
  onClick,
}: {
  title: string;
  selected: boolean;
  onClick: () => void;
}) {
  return (
    <button
      className={`flex items-center gap-2.5 px-4 py-2 rounded-md border hover:bg-[#C326261F] hover:border-[#E43838] cursor-pointer text-[#121212] font-[Inter] text-[12px] not-italic font-semibold leading-[normal] ${
        selected
          ? "bg-[#C326261F] border-[#E43838]"
          : "bg-transparent border-[#BCBCBC]"
      }`}
      onClick={onClick}
    >
      {title}
    </button>
  );
}

// -------------- Profile Highlights V2 --------------

interface ProfileHighlightsV2Props {
  profileMetrics: ProfileMetricType[];
}

function ProfileHighlightsV2({ profileMetrics }: ProfileHighlightsV2Props) {
  return (
    <SectionCardV2
      title="Profile Highlights"
      description="A quick glimpse of the main statistics"
    >
      {/* Profile Highlights content */}
      <div className="w-full rounded-md border border-[#E4E4E4] p-5">
        <ul className="flex justify-between gap-2.5">
          {profileMetrics?.map((item, index, arr) => {
            if (!item?.value || item?.value?.toString() === "0") return null;
            return (
              <React.Fragment key={index}>
                <li key={index} className="flex-1">
                  <div className="flex flex-col gap-1.5 items-center justify-center">
                    <span className="text-[#9C9C9C] font-[Inter] text-[12px] not-italic font-medium leading-[normal]">
                      {item?.key}
                    </span>
                    <span className="text-[#121212] font-[Inter] text-[18px] not-italic font-bold leading-[normal]">
                      {item?.value}
                    </span>
                  </div>
                </li>
                {index < arr?.length - 1 && (
                  <li
                    key={`${index}_divider`}
                    className="h-full py-5 w-px bg-[#E4E4E4]"
                  />
                )}
              </React.Fragment>
            );
          })}
        </ul>
      </div>
    </SectionCardV2>
  );
}

// -------------- Content Details V2 --------------

function TagChipV2({
  text,
  index = 0,
  icon,
  textColor,
  bgColor,
}: {
  text: string;
  index?: number;
  icon?: React.ReactNode;
  textColor?: string;
  bgColor?: string;
}) {
  const colors = [
    {
      bgColor: "bg-[#5F55AF14]",
      textColor: "text-[#5F55AF]",
    },
    {
      bgColor: "bg-[#5F55AF14]",
      textColor: "text-[#756E78]",
    },
  ];
  const { bgColor: bgColorOrdered, textColor: textColorOrdered } =
    colors[index % colors.length];

  bgColor = bgColor || bgColorOrdered;
  textColor = textColor || textColorOrdered;

  return (
    <div
      className={cn(
        "bg-[#5F55AF14] px-1.5 py-1 flex items-center justify-center gap-1 rounded-md",
        bgColor,
        textColor
      )}
    >
      {icon}
      <span
        className={cn(
          "text-[#5F55AF] font-[Inter] text-xs not-italic font-medium leading-[normal]",
          textColor
        )}
      >
        {text}
      </span>
    </div>
  );
}

type categoryWithScoreType = {
  category: string;
  score: number;
};
interface ContentDetailsV2Props {
  createPostCount: number;
  curatePostCount: number;
  categoryWithScore: categoryWithScoreType[];
  masterData: {
    ContentCategory: {
      _id: string;
      categoryName: string;
    }[];
  };
}

function ContentDetailsV2({
  createPostCount,
  curatePostCount,
  categoryWithScore,
  masterData,
}: ContentDetailsV2Props) {
  const colors = [
    {
      fill: "#4B72FF",
    },
    {
      fill: "#3CB38A",
    },
    {
      fill: "#F9C017",
    },
  ];

  const totalCategoryScore = categoryWithScore?.reduce(
    (acc, item) => acc + item?.score,
    0
  );

  const topContentCategory =
    categoryWithScore
      ?.map((item, index) => {
        const color = colors[index % colors.length];
        const percentage = Math.round((item?.score * 100) / totalCategoryScore);

        return {
          name: item?.category,
          label:
            masterData?.ContentCategory?.find((Cc) => Cc?._id == item?.category)
              ?.categoryName || item?.category,
          value: percentage,
          fill: color?.fill,
        };
      })
      .sort((a, b) => b?.value - a?.value) || [];

  // Adjust the percentages to ensure the total is exactly 100%
  const totalPercentage = topContentCategory?.reduce(
    (acc, item) => acc + item?.value,
    0
  );
  const difference = 100 - totalPercentage;

  if (topContentCategory && topContentCategory.length > 0) {
    topContentCategory[0].value += difference;
  }

  const totalPost = createPostCount + curatePostCount;
  const createdPercentage = Math.round((createPostCount * 100) / totalPost);
  const curatedPercentage = Math.round((curatePostCount * 100) / totalPost);

  const TopContentTypes = [
    {
      name: "created",
      label: "Created",
      value: createdPercentage,
      fill: "#4B72FF",
    },
    {
      name: "curated",
      label: "Curated",
      value: curatedPercentage,
      fill: "#3CB38A",
    },
  ];

  const Sections = [
    {
      title: "Top Content Categories",
      description: "Key topics frequently covered by the influencer",
      tags: [
        {
          text: "AI-ANALYSED",
          icon: <Cpu size={16} />,
        },
        {
          text: "LATEST 30 POSTS",
          icon: <Image size={16} />,
        },
      ],
      chart: <DonutPieChart chartData={topContentCategory} />,
      isRenderable: categoryWithScore?.length > 0,
    },
    {
      title: "Content Types",
      description:
        "Shows the balance between original insights & gathered content",
      tags: [
        {
          text: "AI-ANALYSED",
          icon: <Cpu size={16} />,
        },
      ],
      chart: <DonutPieChart chartData={TopContentTypes} />,
      isRenderable: createPostCount > 0 || curatePostCount > 0,
    },
  ];
  return (
    <SectionCardV2
      title="Content Niche & Details"
      description="The influencer's content focus (to measure brand alignment)"
    >
      {/* Content Details content */}
      <ul className="w-full flex gap-5 rounded-md border border-[#E4E4E4] p-5">
        {Sections?.filter((item) => item?.isRenderable)?.map(
          (item, index, array) => (
            <React.Fragment key={index}>
              <li
                key={index}
                className="w-1/2 flex justify-between gap-20 pr-5"
              >
                <div className="flex flex-col gap-4 w-full">
                  {item?.tags?.length > 0 && (
                    <div className="flex gap-4">
                      {item?.tags?.map((item, index) => (
                        <TagChipV2
                          key={index}
                          index={index}
                          text={item?.text}
                          icon={item?.icon}
                        />
                      ))}
                    </div>
                  )}
                  <div className="space-y-1">
                    <h3 className="text-[#121212] font-[Inter] text-[14px] not-italic font-semibold leading-[20px]">
                      {item?.title}
                    </h3>
                    {item?.description && (
                      <p className="text-[#9C9C9C] font-[Inter] text-[12px] not-italic font-medium leading-[normal]">
                        {item?.description}
                      </p>
                    )}
                  </div>
                  {item?.chart}
                </div>
              </li>
              {index < array?.length - 1 && (
                <li
                  key={`${index}_divider`}
                  className="flex h-full justify-center items-center"
                >
                  <div className="h-full py-5 w-px bg-[#E4E4E4]" />
                </li>
              )}
            </React.Fragment>
          )
        )}
      </ul>
    </SectionCardV2>
  );
}

type PieChartDataType = {
  name: string;
  label: string;
  value: number;
  fill: string;
};

interface DonutPieChartProps {
  chartData: PieChartDataType[];
}

export function DonutPieChart({ chartData }: DonutPieChartProps) {
  if (chartData?.length === 0) return null;

  const chartConfig = Object.fromEntries(
    chartData?.map(({ name, label, fill }) => [name, { label, color: fill }])
  ) satisfies Record<string, { label: string; color: string }>;

  return (
    <div className="flex gap-4">
      <div className="w-1/2 grid pb-0 place-items-center">
        <ChartContainer
          config={chartConfig}
          className="aspect-square h-[150px]"
        >
          <PieChart>
            <ChartTooltip
              cursor={false}
              content={<ChartTooltipContent hideLabel />}
            />
            <Pie
              data={chartData}
              dataKey="value"
              nameKey="name"
              innerRadius={45}
              outerRadius={70}
            />
          </PieChart>
        </ChartContainer>
      </div>
      {chartData?.length > 0 && (
        <div className="w-1/2 flex flex-col gap-2 justify-center">
          {chartData?.map((item, index) => (
            <div key={index} className="flex gap-1 items-center">
              <div
                className="w-2 h-4 rounded-[2px]"
                style={{ backgroundColor: item?.fill }}
              ></div>
              <span className="text-[#121212] font-[Inter] text-xs not-italic font-medium leading-[normal]">
                {chartConfig[item.name]?.label}
              </span>
              <span className="flex-1 text-end text-[#121212] font-[Inter] text-xs not-italic font-medium leading-[normal]">
                {item?.value}%
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// -------------- Engagement Details V2 --------------

function EngagementDetailsV2({ firstThirtyComments, firstThirtyLikes }) {
  const Sections = [
    {
      title: "Engagement over time",
      tags: [],
      chart: (
        <PostBarGraphArea
          firstThirtyLikes={firstThirtyLikes}
          firstThirtyComments={firstThirtyComments}
        />
      ),
    },
    // {
    //   title: "Common Topics",
    //   tags: [
    //     {
    //       text: "AI-ANALYSED",
    //       icon: <Cpu size={16} />,
    //     },
    //   ],
    //   chart: <div>Word cloud</div>,
    // },
  ];
  return (
    <SectionCardV2
      title="Engagement Details"
      description="A trend of their engagement, post-wise"
    >
      {/* Engagement Details content */}
      <ul className="w-full flex gap-5 rounded-md border border-[#E4E4E4] p-5">
        {Sections?.map((item, index, array) => (
          <React.Fragment key={index}>
            <li className="w-1/2 flex justify-between gap-20">
              <div className="flex flex-col gap-4 w-full">
                {item?.tags?.length > 0 && (
                  <div className="flex gap-4">
                    {item?.tags?.map((item, index) => (
                      <TagChipV2
                        key={index}
                        index={index}
                        text={item?.text}
                        icon={item?.icon}
                      />
                    ))}
                  </div>
                )}
                <h3 className="text-[#121212] font-[Inter] text-[14px] not-italic font-semibold leading-[20px]">
                  {item?.title}
                </h3>
                {item?.chart}
              </div>
            </li>
            {index < array?.length - 1 && (
              <li
                key={`${index}_divider`}
                className="flex h-full justify-center items-center"
              >
                <div className="h-full py-5 w-px bg-[#E4E4E4]" />
              </li>
            )}
          </React.Fragment>
        ))}
      </ul>
    </SectionCardV2>
  );
}

interface PostBarGraphAreaProps {
  firstThirtyLikes: string[] | undefined;
  firstThirtyComments: string[] | undefined;
}

export const PostBarGraphArea: React.FC<PostBarGraphAreaProps> = ({
  firstThirtyLikes,
  firstThirtyComments,
}) => {
  const [chartData, setChartData] = React.useState([]);

  useEffect(() => {
    const updatedChartData = firstThirtyLikes?.map((item, index) => {
      const originalLikes = parseInt(item);
      const originalComments = parseInt(firstThirtyComments?.[index] || "0");
      const likesLog = Math.log10(originalLikes + 1);
      const commentsLog = Math.log10(originalComments + 1);

      return {
        month: `post ${index + 1}`,
        likes: likesLog,
        comments: commentsLog,
        originalLikes,
        originalComments,
      };
    });

    setChartData(updatedChartData);
  }, [firstThirtyLikes, firstThirtyComments]);

  const chartConfig = {
    comments: {
      label: "Comments",
      color: "#F9C017",
    },
    likes: {
      label: "Likes",
      color: "#4B72FF",
    },
  } satisfies ChartConfig;

  return (
    <>
      <div className="h-full w-full flex flex-col items-center justify-center">
        <ChartContainer config={chartConfig} className="h-[250px] w-full">
          <BarChart accessibilityLayer data={chartData}>
            <CartesianGrid vertical={false} color="#212121" />
            <RechartsTooltip
              content={<CustomTooltip active={undefined} payload={undefined} />}
              cursor={false}
            />
            <ChartLegend content={<ChartLegendContent />} />
            <Bar
              width={5}
              dataKey="likes"
              stackId="a"
              fill="var(--color-likes)"
              radius={[0, 0, 4, 4]}
            />
            <Bar
              width={5}
              dataKey="comments"
              stackId="a"
              fill="var(--color-comments)"
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ChartContainer>

        <div className="w-full flex items-center justify-between">
          <span className=" text-xs font-medium leading-[14.52px] text-center text-[#A3A3A3]">
            Latest
          </span>
          <span className=" text-xs font-medium leading-[14.52px] text-center text-[#A3A3A3]">
            Oldest
          </span>
        </div>
      </div>
    </>
  );
};

// -------------- Most Engaged Posts V2 --------------

interface TopPostCardV2Props {
  profile: string;
  name: string;
  postDescription: string;
  likes: number;
  comments: number;
  reposts: number;
  postLink: string;
  tagline: string;
  date: string;
}

function TopPostCardV2({
  profile,
  name,
  postDescription,
  likes,
  comments,
  reposts,
  postLink,
  tagline,
  date,
}: TopPostCardV2Props) {
  return (
    <>
      <div className="transition-transform hover:scale-105 hover:shadow h-full p-4 flex flex-col  gap-[20px]  border border-solid border-[#EEE] rounded-[10px] bg-[#FFF] justify-between">
        <div className="flex flex-col  gap-[20px]">
          <div className="w-full items-center justify-start flex gap-4">
            <div className="overflow-hidden w-[50px] h-[50px]  rounded-full shrink-0 ">
              <img
                className="w-[50px] h-[50px] cover shrink-0"
                src={profile}
                alt=""
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                onError={(e: any) => {
                  const randomProfileEmoji = getRandomProfileEmoji();
                  e.target.onerror = null;
                  e.target.src = randomProfileEmoji;
                }}
              />
            </div>
            <div className=" flex flex-col gap-1">
              <div className="flex items-center gap-1.5">
                <span className="text-[#121212] font-[Inter] text-[14px] not-italic font-semibold leading-[normal]">
                  {name}
                </span>
                <span className="text-[#585C60] font-[Inter] text-[12px] not-italic font-normal leading-[normal]">
                  •
                </span>
                <span className="text-[#585C60] font-[Inter] text-[12px] not-italic font-normal leading-[normal]">
                  1st
                </span>
              </div>
              <span className="text-[#121212] font-[Inter] text-[12px] not-italic font-normal leading-[normal] line-clamp-1">
                {tagline}
              </span>
              {date && (
                <div className="flex items-center gap-1.5 text-[#585C60] font-[Inter] text-[12px] not-italic font-normal leading-[normal]">
                  <span>{date}</span>
                  <span>•</span>
                  <Earth size={14} />
                </div>
              )}
            </div>
          </div>
          <div className="flex flex-wrap flex-col gap-1 ">
            <div className="text-[#545454] font-[Inter] text-[12px] not-italic font-normal leading-[18px] break-all text-xs  text-left line-clamp-[9] whitespace-pre-wrap">
              {postDescription}
            </div>
            <span
              onClick={() => OpenInNewWindow({ link: postLink })}
              className=" cursor-pointer text-xs font-bold leading-[14.52px] text-left text-[#666666] line-clamp-4"
            >
              view more
            </span>
          </div>
        </div>

        <div className="grid gap-[20px] grid-cols-3">
          {[
            {
              icon: (
                <ThumbsUp
                  size={20}
                  color="#004182"
                  fill="#D0E8FF"
                  className="scale-x-[-1]"
                />
              ),
              key: "Avg. Engagement",
              value: `${likes ?? "NA"}`,
              bgColor: "bg-[#378FE9]",
            },
            {
              icon: <MessageSquare size={20} color="#5D3B01" fill="#FCF0DE" />,
              key: "Avg. Likes",
              value: `${comments ?? "NA"}`,
              bgColor: "bg-[#F5BB5C]",
            },
            {
              icon: <Send size={20} color="#057642" fill="#DDF6D1" />,
              key: "Avg. Comments",
              value: `${reposts ?? "NA"}`,
              bgColor: "bg-[#6DAE4F]",
            },
          ]?.map((item, index) => {
            if (item?.value?.toString() === "0" || item?.value === "NA")
              return null;
            return (
              <div
                key={index}
                className="flex gap-1.5 items-center text-xs font-normal leading-[14.52px] text-left text-[#666666]"
              >
                <span
                  className={cn(
                    "rounded-full p-1 flex items-center justify-center",
                    item?.bgColor
                  )}
                >
                  {item.icon}
                </span>
                <span>{item?.value}</span>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

function MostEngagedPostsV2({ topPosts = [], name, tagline, profileImage }) {
  const optimizedTopPosts = topPosts?.map((post) => {
    const {
      reposts,
      comments,
      postDescription,
      likes,
      postFeedUrl,
      postCreatedOn,
    } = post;
    return {
      postDescription,
      likes,
      comments,
      reposts: reposts === comments ? 0 : reposts,
      postFeedUrl,
      postCreatedOn,
    };
  });

  return (
    <SectionCardV2
      title="Most Engaged Posts"
      description="Top 3 posts with the highest engagement"
    >
      {/* Most Engaged Posts content */}
      <div className="w-full flex gap-5 rounded-md border border-[#E4E4E4] p-5">
        <ul className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {optimizedTopPosts?.map((post, index) => (
            <li key={index} className="w-full">
              <TopPostCardV2
                name={name}
                tagline={tagline}
                profile={profileImage}
                postDescription={post?.postDescription}
                likes={post?.likes}
                comments={post?.comments}
                reposts={post?.reposts}
                postLink={post?.postFeedUrl}
                date={
                  post?.postCreatedOn
                    ? format(new Date(post?.postCreatedOn), "dd MMM, yy")
                    : null
                }
              />
            </li>
          ))}
        </ul>
      </div>
    </SectionCardV2>
  );
}

// -------------- Audience Details V2 --------------

interface ProgressBarProps {
  value: number;
  max: number;
  index?: number;
  bgColor?: string;
}

function ProgressBar({ value, max, bgColor }: ProgressBarProps) {
  const percentage = (value / max) * 100;

  return (
    <div className="h-2 w-full rounded-full bg-[#426CEA14]">
      <div
        className={`h-full rounded-full ${bgColor}`}
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
}

type AudienceType = {
  title: string;
  percentage: string;
  // value: number;
};

interface AudienceDetailsV2Props {
  jobTitles: AudienceType[];
  locations: AudienceType[];
  seniority: AudienceType[];
}
function AudienceDetailsV2({
  jobTitles,
  locations,
  seniority,
}: AudienceDetailsV2Props) {
  const colors = [
    {
      bgColor: "bg-[#D66A57]",
    },
    {
      bgColor: "bg-[#3CB38A]",
    },
    {
      bgColor: "bg-[#F9C017]",
    },
    {
      bgColor: "bg-[#3265FE]",
    },
    {
      bgColor: "bg-[#3998B4]",
    },
  ];

  const Sections = [
    {
      title: "Job Title",
      metrics: jobTitles?.map((item, index) => ({
        title: item?.title,
        value: item?.percentage,
        percentage:
          parseFloat(item?.percentage?.replace(/[%<>=,]/g, "")?.trim()) -
          (item?.percentage?.includes("<") ? (index + 1) / 100 : 0),
      })),
      barColor: colors[1]?.bgColor,
      icon: <Briefcase size={14} />,
    },
    {
      title: "Location",
      metrics: locations?.map((item, index) => ({
        title: item?.title,
        value: item?.percentage,
        percentage:
          parseFloat(item?.percentage?.replace(/[%<>=,]/g, "")?.trim()) -
          (item?.percentage?.includes("<") ? (index + 1) / 100 : 0),
      })),
      barColor: colors[2]?.bgColor,
      icon: <MapPin size={14} />,
    },
    {
      title: "Seniority",
      metrics: seniority?.map((item, index) => ({
        title: item?.title,
        value: item?.percentage,
        percentage:
          parseFloat(item?.percentage?.replace(/[%<>=,]/g, "")?.trim()) -
          (item?.percentage?.includes("<") ? (index + 1) / 100 : 0),
      })),
      barColor: colors[3]?.bgColor,
      icon: <Users size={14} />,
    },
  ];

  return (
    <SectionCardV2
      title="Audience Details"
      description="Most recent audience demographics (last 90 days)"
    >
      {/* Audience Details content */}
      <div className="w-full rounded-md border border-[#E4E4E4] p-5 space-y-4">
        <div className="flex gap-2">
          <TagChipV2
            text="Via LinkedIn Analytics"
            icon={<AreaChart size={14} />}
            bgColor={"bg-[#92400E14]"}
            textColor={"text-[#92400E]"}
          />
        </div>
        <ul className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {/* columns */}
          {Sections?.map((section, index, array) => {
            const maxValue =
              section?.metrics?.length > 0
                ? Math.max(
                    ...section.metrics.map((metric) => metric?.percentage || 0)
                  )
                : 100;
            return (
              <React.Fragment key={index}>
                <li key={index} className="flex gap-5">
                  <div className="flex-1 space-y-5">
                    <div className="flex items-center gap-2 text-gray-400">
                      {/* <Users className="size-4" /> */}
                      {section?.icon}
                      <h2 className="text-[#121212] text-center font-[Inter] text-[14px] not-italic font-semibold leading-[normal]">
                        {section?.title}
                      </h2>
                    </div>
                    <div className="space-y-3">
                      {section?.metrics?.map((metric, i) => (
                        // rows
                        <div key={i} className="space-y-2">
                          <div className="text-[#757575] font-[Inter] text-[14px] not-italic font-medium leading-[normal]">
                            {metric?.title}
                          </div>
                          <div className="flex items-center gap-4">
                            {/* progress */}
                            <ProgressBar
                              value={metric?.percentage}
                              max={maxValue}
                              bgColor={section?.barColor}
                            />
                            <span className="shrink-0 text-[#757575] font-[Inter] text-[12px] not-italic font-normal leading-[normal]">
                              {metric?.value}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  {index < array?.length - 1 && (
                    <div
                      key={`${index}_divider`}
                      className="flex h-full justify-center items-center"
                    >
                      <div className="h-full py-5 w-px bg-[#E4E4E4]" />
                    </div>
                  )}
                </li>
              </React.Fragment>
            );
          })}
        </ul>
      </div>
    </SectionCardV2>
  );
}

// -------------- Past Collaborations V2 --------------

type CollabType = {
  companyName: string;
  companyUrl: string;
  goals: string;
  postLink: string;
  isVerified: number;
  scrapedData: {
    postContent: string;
  };
};
interface PastCollaborationsV2Props {
  AllCollabs: CollabType[];
}

function PastCollaborationsV2({ AllCollabs }: PastCollaborationsV2Props) {
  return (
    <SectionCardV2
      title="Past Collaborations"
      description="The influencer's collaboration history with brands"
    >
      {/* Past Collaborations content */}
      <div className="w-full rounded-md border border-[#E4E4E4] p-5 space-y-4">
        <ul className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {AllCollabs?.map((collab, index) => (
            <li key={index}>
              <CollabCardV2
                index={index}
                companyName={collab?.companyName}
                companyUrl={collab?.companyUrl}
                postLink={collab?.postLink}
                isVerified={collab?.isVerified}
                postContent={collab?.scrapedData?.postContent}
              />
            </li>
          ))}
        </ul>
      </div>
    </SectionCardV2>
  );
}

interface CollabCardV2Props {
  index?: number;
  isVerified?: number;
  companyName: string;
  companyUrl: string;
  postLink: string;
  postContent: string;
}

function CollabCardV2({
  index = 0,
  isVerified,
  companyName,
  postLink,
  postContent,
}: CollabCardV2Props) {
  const colors = [
    {
      bgColor: "bg-gradient-to-b from-[#F6D5F7] to-[#FBE9D7]",
      textColor: "text-[#302E2E]",
    },
    {
      bgColor: "bg-gradient-to-b from-[#8DD0FC80] to-[#DDB4F680]",
      textColor: "text-[#000000]",
    },
    {
      bgColor: "bg-gradient-to-b from-[#CAD0FF] to-[#F2F6D1]",
      textColor: "text-[#302E2E]",
    },
    {
      bgColor: "bg-gradient-to-b from-[#FFBAB1] to-[#F2F6D1]",
      textColor: "text-[#302E2E]",
    },
    {
      bgColor: "bg-gradient-to-b from-[#FFE5D9] to-[#C9EAFF]",
      textColor: "text-[#302E2E]",
    },
    {
      bgColor: "bg-gradient-to-b from-[#B6EDC8] to-[#F8DADC]",
      textColor: "text-[#302E2E]",
    },
    {
      bgColor: "bg-gradient-to-b from-[#2C6CBC] to-[#71C3F7]",
      textColor: "text-[#FFFFFF]",
    },
    {
      bgColor: "bg-gradient-to-b from-[#C9EFDC] to-[#CAD0FF]",
      textColor: "text-[#302E2E]",
    },
    {
      bgColor: "bg-gradient-to-b from-[#FBD07C] to-[#FFFFC0]",
      textColor: "text-[#302E2E]",
    },
    {
      bgColor: "bg-gradient-to-b from-[#F13C7780] to-[#F5E6AD80]",
      textColor: "text-[#000000]",
    },
  ];
  const { bgColor, textColor } = colors[index % colors.length];

  const allTopTags = useMemo(() => {
    const tags = [];
    if (isVerified === 1) {
      tags.push({
        text: "Verified",
        icon: <ShieldCheck size={14} />,
        bgColor: "bg-[#3B81FA14]",
        textColor: "text-[#3B81FA]",
      });
    }
    return tags;
  }, [isVerified]);

  return (
    <div className="transition-transform hover:scale-105 hover:shadow p-3 bg-white rounded-md border border-[#E4E4E4] flex flex-col justify-between gap-3 h-full">
      <div className="flex flex-col gap-3">
        {allTopTags?.length > 0 && (
          <ul className="flex gap-2">
            {allTopTags?.map((tag, index) => (
              <TagChipV2
                key={index}
                index={index}
                text={tag?.text}
                icon={tag?.icon}
                bgColor={tag?.bgColor}
                textColor={tag?.textColor}
              />
            ))}
          </ul>
        )}
        <div
          className={cn("p-2 rounded-sm h-20 grid place-items-center", bgColor)}
        >
          <h3
            className={cn(
              "font-[Inter] text-[14px] not-italic font-semibold leading-[normal]",
              textColor
            )}
          >
            {companyName}
          </h3>
        </div>
        {postContent?.trim()?.length > 0 && (
          <div>
            <p className="line-clamp-3 text-[#757575] font-[Inter] text-[12px] not-italic font-normal leading-[22px] ">
              {postContent}
            </p>
          </div>
        )}
      </div>
      {postLink?.trim()?.length > 0 && (
        <button
          className="flex items-center justify-center gap-2 py-2 px-3 text-[#484848] hover:text-[#237FFF] hover:bg-[#FBFBFB] rounded-md"
          onClick={() => {
            mixpanel.track(`Clicked Proof on Collaboration History`, {
              companyName: companyName,
              postLink: postLink,
            });
            window.open(convertToUrl(postLink), "_blank");
          }}
        >
          <span className="font-[Inter] text-[12px] not-italic font-medium leading-[18px]">
            View Full Post
          </span>
          <SquareArrowOutUpRight size={14} color="#237FFF" />
        </button>
      )}
    </div>
  );
}
